// 基础核心翻译
import rules from './rules.json';
import common from './common.json';
import core from './core.json';
import api from './api.json';
import menu from './menu.json';
import message from './message.json';
import components from './components.json';
import login from './login.json';
import exceptError from './exceptError.json';
import member from './member.json';
import betRecord from './betRecord.json';
import memberCenter from './memberCenter.json';
import identify from './identify.json';
import blacklist from './blackList.json';
import account from './account.json';

export default {
  ...common,
  ...components,
  member,
  rules,
  core,
  api,
  menu,
  message,
  login,
  exceptError,
  betRecord,
  memberCenter,
  identify,
  blacklist,
  account
};
